import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuthHandler, useBreakpoint } from '@/core/hooks';
import { Header, SideBar } from '@/core/layout';
import { Drawer } from '@/core/ui';
import { useGlobal } from '@/store';

export default function RootLayout() {
  const { getAuthInfo } = useAuthHandler();
  const pathName = useLocation().pathname;
  const sideBar = useGlobal.use.sideBar();
  const setSideBar = useGlobal.use.setSideBar();
  const breakpoint = useBreakpoint();

  useEffect(() => {
    getAuthInfo();
  }, []);

  return (
    <>
      {/* <Banner className='h-[40px]' /> */}
      <main className='flex min-h-screen overflow-hidden w-full bg-primary-50'>
        {/* ------------------------------------------- */}
        {/* Sidebar */}
        {/* ------------------------------------------- */}

        {breakpoint.value > 2 ? (
          <div className='flex-col z-[6]'>
            <SideBar />
          </div>
        ) : (
          <Drawer position='left' open={sideBar} onClose={() => setSideBar(false)}>
            <SideBar />
          </Drawer>
        )}
        {/* ------------------------------------------- */}
        {/* Main Wrapper */}
        {/* ------------------------------------------- */}
        <section className='flex flex-grow flex-col z-[6]'>
          {/* ------------------------------------------- */}
          {/* Header */}
          <Header className='h-[80px]' breadCrumbs={pathName.split('/').filter(Boolean)} />
          {/* PageContent */}
          {/* ------------------------------------------- */}
          <div className='h-full'>
            {/* ------------------------------------------- */}
            {/* Page Route */}
            {/* ------------------------------------------- */}
            <div className='p-4 md:p-6 overflow-y-auto scrollbar-thin h-full max-h-[calc(100vh-80px)]'>
              <Outlet />
            </div>
            {/* ------------------------------------------- */}
            {/* End Page */}
            {/* ------------------------------------------- */}
          </div>
        </section>
      </main>
    </>
  );
}
